import { createSelector } from '@ngrx/store';
import { Prescription, PrescriptionPagination } from 'vidis-common/prescription';
import { AppState } from '../reducers/app.state';

export const selectPrescriptionHasHiddenPrescription = (state: AppState) => state.prescriptionsData.hasHiddenPrescriptions;
export const selectPrescriptionsStatePrescriptions = (state: AppState) => state.prescriptionsData.items;
export const selectPrescriptionsStatePrescriptionsError = (state: AppState) => state.prescriptionsData.errors;
export const selectTotalAmountOfPrescriptions = (state: AppState) => state.prescriptionsData.totalItems;
export const selectPrescriptionsLoading = (state: AppState) => state.prescriptionsData.loading;
export const selectPrescriptionsStateIsLoaded = (state: AppState) => state.prescriptionsData.isLoaded;
export const selectFilter = (state: AppState) => state.prescriptionsData.filter;
export const selectPagination = (state: AppState): PrescriptionPagination => state.prescriptionsData.pagination;

export const selectPrescriptionsByRidCode = (ridCode: string) => createSelector(
  selectPrescriptionsStatePrescriptions,
  (prescriptions: Prescription[]) =>
    prescriptions?.length > 0 ? prescriptions.find(presc => presc.ridCode === ridCode) : null
);
